import styled from "styled-components";
import React, { useCallback, useState } from "react";
import BaseReader, { ReaderProps } from "./BaseReader";
import useJigsawEvent from "../viewer-context/useJigsawEvent";
import JigsawEvent from "../viewer-context/JigsawEvent";
import { TOOLBAR_HEIGHT } from "components/ReaderToolBar/consts";
import useBrandProp from "components/brand-context/useBrandProp";

const Styled = {
  OuterContainer: styled.div`
    width: 100%;
    height: 100%;
  `,
};

export default function Reader({ ...props }: ReaderProps) {
  const [scrollTop, setScrollTop] = useState(0);
  const readerToolbarEnabled = useBrandProp("ReaderToolbar.enabled");

  const handleScroll = useCallback(
    (evt, data) => {
      // For performance reasons, only process the events that can change the padding
      const scrollingInSafeZone = data.scrollTop <= TOOLBAR_HEIGHT;
      const exitedSafeZone =
        scrollTop <= TOOLBAR_HEIGHT && data.scrollTop > TOOLBAR_HEIGHT;
      if (scrollingInSafeZone || exitedSafeZone) {
        setScrollTop(data.scrollTop);
      }
    },
    [scrollTop]
  );

  useJigsawEvent(JigsawEvent.PAGE_SCROLL_FULLSPEED, handleScroll);

  const paddingTop =
    !readerToolbarEnabled || scrollTop > TOOLBAR_HEIGHT
      ? 0
      : TOOLBAR_HEIGHT - scrollTop;

  return (
    <Styled.OuterContainer style={{ paddingTop }}>
      <BaseReader {...props} />
    </Styled.OuterContainer>
  );
}
